import { render, staticRenderFns } from "./CrudEditableTable.vue?vue&type=template&id=df5e0322&scoped=true"
import script from "./CrudEditableTable.vue?vue&type=script&lang=js"
export * from "./CrudEditableTable.vue?vue&type=script&lang=js"
import style0 from "./CrudEditableTable.vue?vue&type=style&index=0&id=df5e0322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5e0322",
  null
  
)

export default component.exports